import { blogActions } from '../actions/blogActions';

  const initialState = {
      blogs: [],
      images: [],
      loading: false,
      error: null,
      hasMore: true, // Keep track of whether there are more blogs to load
      currentPage: 1, // Track the current page
      blogContent: "",
      images: [], // array of image objects or URLs
    };
  
  const blogReducer = (state = initialState, action) => {
    switch (action.type) {

      case blogActions.FETCH_BLOGS_REQUEST:
        return {
          ...state,
          loading: true,
          error: null,
        };
  
      case blogActions.FETCH_BLOGS_SUCCESS:
        const { blogs, hasMore, currentPage } = action.payload;
        return {
          ...state,
          loading: false,
          blogs: currentPage === 1 ? blogs :  blogs,
          hasMore,
          currentPage, // Set the current page
        };
  
      case blogActions.FETCH_BLOGS_FAILURE:
        return {
          ...state,
          loading: false,
          error: action.payload,
        };
        
        case blogActions.UPLOAD_IMAGE_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case blogActions.UPLOAD_IMAGE_SUCCESS:
      return {
        ...state,
        loading: false,
        images: state.images ? [...state.images, action.payload] : [action.payload],
      };

    case blogActions.UPLOAD_IMAGE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // Image Removal Actions
    case blogActions.REMOVE_IMAGE_SUCCESS:
      const { payload: removedUrls } = action;
      return {
        ...state,
        images: state.images.filter((image) => !removedUrls.includes(image.url)),
      };

    case blogActions.REMOVE_IMAGE_FAILURE:
      return {
        ...state,
        error: action.payload,
      };

    // Blog Save Actions
    case blogActions.SAVE_BLOG_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case blogActions.SAVE_BLOG_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
      };

    case blogActions.SAVE_BLOG_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
      case blogActions.FETCH_BLOG_REQUEST_BYID:
      return {
        ...state,
        loading: true,
        blog: null,
        error: null,
      };

    case blogActions.FETCH_BLOG_SUCCESS_BYID:
      return {
        ...state,
        loading: false,
        blog: action.payload,  // Store the fetched blog data
        error: null,
      };

    case blogActions.FETCH_BLOG_FAILURE_BYID:
      return {
        ...state,
        loading: false,
        blog: null,
        error: action.payload,  // Store the error message
      };

      case blogActions.DELETE_BLOG_REQUEST:
      return {
        ...state,
        loading: true,
      };

    case blogActions.DELETE_BLOG_SUCCESS:
      return {
        ...state,
        loading: false,
        blogs: state.blogs.filter((blog) => blog.id !== action.payload),
      };

    case blogActions.DELETE_BLOG_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
  
      default:
        return state;
    }
  };
export default blogReducer;
